export const DATA = [
  {
    section: `워크스페이스\n관리`,
    pages: [
      {
        title: "멤버 관리",
        owner: true,
        superAdmin: true,
        policyAdmin: false,
        securityAdmin: false,
        staff: false,
      },
      {
        title: "서비스 플랜 관리",
        owner: true,
        superAdmin: true,
        policyAdmin: false,
        securityAdmin: false,
        staff: false,
      },
      {
        title: `워크스페이스\n정보 관리`,
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: false,
        staff: false,
      },
      {
        title: "워크스페이스 삭제",
        owner: true,
        superAdmin: false,
        policyAdmin: false,
        securityAdmin: false,
        staff: false,
      },
    ],
  },
  {
    section: `회원 정보\n관리`,
    pages: [
      {
        title: "내 정보 관리",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: true,
        staff: true,
      },
      {
        title: "서비스 연동 관리",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: true,
        staff: true,
      },
    ],
  },
  {
    section: "Mile Meeting",
    pages: [
      {
        title: "예약 현황",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: true,
        staff: true,
      },
      {
        title: "나의 예약/참석",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: true,
        staff: true,
      },
      {
        title: "나의 알림 설정",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: true,
        staff: true,
      },
      {
        title: "회의실 예약 제한 요청",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: true,
        staff: true,
      },
      {
        title: "운영/예약 정책 관리",
        owner: true,
        superAdmin: true,
        policyAdmin: undefined,
        securityAdmin: false,
        staff: false,
      },
      {
        title: "회의실 등록 및 설정",
        owner: true,
        superAdmin: true,
        policyAdmin: undefined,
        securityAdmin: false,
        staff: false,
      },
      {
        title: "회의실 기기 관리",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: false,
        staff: false,
      },
      {
        title: "회의실 민원 관리",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: undefined,
        staff: undefined,
      },
      {
        title: "노쇼 예약 조회",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: false,
        staff: false,
      },
      {
        title: "노쇼 예약 취소",
        owner: true,
        superAdmin: true,
        policyAdmin: false,
        securityAdmin: false,
        staff: false,
      },
    ],
  },
  {
    section: "Mile Visitors",
    pages: [
      {
        title: "나의 방문 관리",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: true,
        staff: true,
      },
      {
        title: "서비스 커스터마이징",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: false,
        staff: false,
      },
      {
        title: "기기 관리",
        owner: true,
        superAdmin: true,
        policyAdmin: true,
        securityAdmin: false,
        staff: false,
      },
    ],
  },
  {
    section: "Mile Analytics",
    pages: [
      {
        title: "Mile Meeting Analytics",
        owner: true,
        superAdmin: true,
        policyAdmin: false,
        securityAdmin: true,
        staff: false,
      },
      {
        title: "Mile Visitors Analytics",
        owner: true,
        superAdmin: true,
        policyAdmin: false,
        securityAdmin: true,
        staff: false,
      },
    ],
  },
];
